import React, { useState, useEffect } from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import Footer1 from "../footer/footer1";
import { notification } from "antd";
import { baseApiUrl } from "../../../services/api";

function Besoins() {
  const [besoins, setBesoins] = useState([]);
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [emailError, setEmailError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [nomError, setNomError] = useState("");

  // Fonction pour afficher les notifications
  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  // Fonction pour récupérer les besoins existants
  const fetchBesoins = async () => {
    try {
      const response = await baseApiUrl.get("/besoins");
      setBesoins(response.data);
    } catch (error) {
      console.error("Erreur lors de la récupération des besoins:", error);
    }
  };

  // Charger les besoins au chargement du composant
  useEffect(() => {
    fetchBesoins();
  }, []);

  // Réinitialiser le formulaire
  const resetForm = () => {
    setNom("");
    setEmail("");
    setMessage("");
    setNomError("");
    setEmailError("");
    setMessageError("");
  };

  // Fonction pour gérer l'ajout d'un besoin
  const handleAddBesoin = async (e) => {
    e.preventDefault();

    // Réinitialiser les messages d'erreur
    setNomError("");
    setEmailError("");
    setMessageError("");

    // Validation des champs
    let hasError = false;

    if (!nom) {
      setNomError('Veuillez entrer un nom');
      hasError = true;
    }

    if (!email) {
      setEmailError('Veuillez entrer un email');
      hasError = true;
    }

    if (!message) {
      setMessageError('Veuillez saisir votre besoin');
      hasError = true;
    }

    if (hasError) {
      openNotificationWithIcon("error", "Veuillez remplir tous les champs obligatoires.");
      return;
    }

    try {
      const besoinData = {
        nom,
        email,
        message,
        isRead: false
      };

      const response = await baseApiUrl.post("/besoins", besoinData);
      const newBesoin = response.data;

      setBesoins([newBesoin, ...besoins]);

      openNotificationWithIcon("success", "Votre besoin a été envoyé avec succès.");
      fetchBesoins();
      resetForm();
    } catch (error) {
      openNotificationWithIcon("error", "Erreur lors de l'envoi de votre besoin.");
      console.error("Erreur détectée:", error.response?.data || error.message || error);
    }
  };

  return (
    <div className="besoins-page">
      <Header />
      <div
        className="inner-hero bg-cover"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/inner-hero-bg.jpg)`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-heading">
                <h1>Exprimez vos besoins</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-page-sec sp">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto">
              <div className="contact-page-from">
                <form onSubmit={handleAddBesoin}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="single-input">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Votre nom et prénom"
                          value={nom}
                          onChange={(e) => setNom(e.target.value)}
                          required
                        />
                        {nomError && (
                          <small className="text-danger">{nomError}</small>
                        )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="single-input">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Votre adresse mail"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        {emailError && (
                          <small className="text-danger">{emailError}</small>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="single-input">
                        <textarea
                          className="form-control"
                          placeholder="Décrivez votre besoin"
                          rows="10"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                          style={{ height: "200px" }}
                        ></textarea>
                        {messageError && (
                          <small className="text-danger">{messageError}</small>
                        )}
                      </div>

                      <div className="row" style={{marginTop:"20px"}}>
                        <div className="col-md-12">
                          <div className="button mt-30" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <button className="theme-btn1" type="submit">
                              Envoyer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer1 />
      <Footer />
    </div>
  );
}

export default Besoins;
